import * as React from "react";
import Box from "@mui/material/Box";
import FormLabel from "@mui/material/FormLabel";
import { Button, Typography } from "@mui/material";
import { useSelector, useDispatch } from "react-redux";
import * as actions from "../../../../../../src/actions/actions";
import CustomizedSnackbars from "../../../../../components/Toast";
import { Link } from "react-router-dom";

const SessionNotesTab = (props) => {
  const dispatch = useDispatch();

  const [errors, setErrors] = React.useState({});
  const [showToast, setShowToast] = React.useState(false);
  const [snackbar, setSnackbar] = React.useState({ text: "", severity: "" });
  const [raceSessionData, setRaceSessionData] = React.useState("");
  const [saveLoader, setSaveLoader] = React.useState(false);
  const [raceSessionURL, setRaceSessionURL] = React.useState("");

  const initialNotes = useSelector(
    (state) => state.raceSessionNotes.raceSessionNotes.data
  );

  React.useEffect(() => {
    console.log("The sessionId", props.sessionId);
    dispatch(actions.fetchRaceSessionForNotes(props.sessionId));
  }, [props.sessionId]);

  React.useEffect(() => {
    setRaceSessionData(initialNotes.sessionNotes || "");
  }, [initialNotes]);

  React.useEffect(() => {
    setRaceSessionURL(
      "../../../raceday/race-session?eventId=" +
      props.event +
      "&sessDate=" +
      props.raceSessionsDate
    );
  }, [props.event, props.raceSession]);

  function validationPopup(msg, status) {
    setShowToast(true);
    setSnackbar({ text: msg, severity: status });
    setTimeout(() => {
      setSnackbar({ text: "", severity: status });
      setShowToast(false);
    }, 2000);
  }

  const handleChange = (event) => {
    setRaceSessionData(event.target.value);
  };

  const handleSaveDetails = async () => {
    let sessionObj = {
      raceSessionId: props.sessionId,
      sessionNotes: raceSessionData,
    };
    console.log("the notes data", sessionObj);
    try {
      const response = await dispatch(
        actions.createUpdateRaceSessionNotes(sessionObj)
      );
      console.log("response", response);
      if (!response.status) {
        validationPopup(response.data.message, "error");
      } else {
        validationPopup("Notes saved successfully!", "success");
      }
    } catch (e) {
      validationPopup("Couldn't save the notes", "error");
    }
  };

  return (
    <>
      <Box
        sx={{
          display: "flex",
          alignItems: {
            lg: "center",
            sm: "flex-start",
          },
          justifyContent: "space-between",
          // marginBottom: "32px",
          flexDirection: {
            xs: "column",
            sm: "column",
            md: "row",
            lg: "row",
          },
          rowGap: {
            md: "0px",
            sm: "0px",
            xs: "0px",
          },
        }}
      >
        <Typography
          sx={{ marginTop: "0 !important" }}
          variant="h4"
          className="ty_form_heading"
        >
          Session Notes
        </Typography>
        <CustomizedSnackbars
          severity={snackbar.severity}
          open={snackbar.text !== ""}
          setShowToast={setShowToast}
          text={snackbar.text}
        />
        <Box sx={{ display: "flex", alignItems: "center", gap: "16px", marginTop: { sm: "8px" } }}>
          <Button
            className="ty_secondary_btn"
            component={Link}
            to={raceSessionURL}
          >
            Return To Race Session
          </Button>
          {/* <Button className="ty_secondary_btn">Go to Race Results</Button> */}
        </Box>
      </Box>

      <Box mb={5}>
        <FormLabel
          className="ty-uppercase-label"
          sx={{
            display: "block",
            width: "100%",
            marginBottom: "10px",
            marginTop: { sm: "0.5rem", xs: "0.5rem", md: "0.5rem", lg: "0rem" },
          }}
        >
          Session Note
          {/* <span className="label_red_star">*</span> */}
        </FormLabel>
        <textarea
          rows={6}
          placeholder="Write Here..."
          value={raceSessionData}
          onChange={handleChange}
          fullWidth
          style={{ resize: "none" }}
          resize="none"
          // variant="outlined"
          sx={{ marginBottom: "16px", padding: "0.5rem", }}
        />
        <Button
          sx={{ float: "right", marginTop: "30px" }}
          className="ty_secondary_btn"
          onClick={handleSaveDetails}
        // USER CAN NOW SAVE EMPTY FIELDS ALSO IF HE WANTS TO CLEAR NOTES
        // disabled={raceSessionData.length==0}
        >
          Save
        </Button>
      </Box>
    </>
  );
};

export default SessionNotesTab;
